import { useQuery } from 'react-query'

import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { DetailedCard } from '@webapp/modules/spending-cards/entities/DetailedCard'
import { cardQueryConfig } from '@webapp/modules/spending-cards/query-configs/card'

type UseQueryDetailedCardReturn = {
  detailedCard: Nullable<DetailedCard>
  refetch: () => void
  isFetching: boolean
}

export const useQueryDetailedCard = ({
  externalId,
  enabled = true,
  onError,
}: {
  externalId: string
  enabled?: boolean
  onError?: (error: Error) => void
}): UseQueryDetailedCardReturn => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: cardQueryConfig.detailedCard(externalId).queryKey,
    queryFn: () => cardRepository.getCardDetails({ externalId }),
    enabled,
    onError,
  })

  return {
    detailedCard: data?.data ? new DetailedCard(data.data) : null,
    refetch,
    isFetching,
  }
}
